<template>
    <div id="check_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        <span id="checkHeader" v-if="$route.params.id > 0">Update Check</span>
                        <span id="checkHeader" v-else>Add Check</span>
                        <button type="submit" class="btn btn-success waves-effect pull-right back-btn-fl" v-on:click.prevent="BackChecksList">
                               <i class="hi-icon icon-flback"> </i> Back
                        </button>
                    </div>
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <div class="container">
                                <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="checkForm">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="form-group">

                                                <template v-if="isUpdate">
                                                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                        <label class="control-label" for="check_number">Check #: {{check_number}}</label>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                        <label class="control-label required" for="from_number">From Number:</label>
                                                        <input type="text" class="form-control" v-model="from_number" id="from_number" placeholder="Enter From Number" name="from_number" @keypress="isNumberKey($event)">
                                                        <div class="c-error">{{from_number_error_msg}}</div>
                                                    </div>

                                                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                        <label class="control-label required" for="to_number">To Number:</label>
                                                        <input type="text" class="form-control" v-model="to_number" id="to_number" placeholder="Enter To Number" name="to_number" @keypress="isNumberKey($event)">
                                                        <div class="c-error">{{to_number_error_msg}}</div>
                                                    </div>
                                                </template>

                                                <div class="clearfix"></div>

                                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                    <label class="control-label required" for="check_status">Status:</label>
                                                    <v-select v-model="check_status" name="check_status" placeholder="Select Status."
                                                            label="text"
                                                            :options="checkStatusArr" id="check_status" class="close-remove">
                                                    </v-select>
                                                    <div class="c-error">{{check_status_error_msg}}</div>
                                                </div>

                                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                    <label class="control-label" for="check_status">Comment:</label>
                                                    <textarea class="form-control rounded-0" v-model="comment" ref="textarea" id="comment" rows="3" ></textarea>
                                                </div>

                                                <div class="clearfix"></div>

                                                <div class="col-sm-6">
                                                    <div class="c-error check-error">{{common_error_msg}}</div>
                                                </div>
                                                <div class="clearfix"></div>

                                                <div class="form-group">
                                                    <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                        <strong id="errorMsg" class="error"></strong>
                                                    </div>
                                                </div>

                                                <div class="col-sm-12 btm-action-btn-fl">

                                                    <button type="submit" id="CreateCheckBtn" v-if="$route.params.id > 0" class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateCheck" >
                                                        <i class="hi-icon icon-flUpdate-data"> </i>  Update
                                                    </button>

                                                    <button type="submit" id="CreateCheckBtn" v-else class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateCheck" >
                                                        <i class="hi-icon icon-flSave"> </i>  Save
                                                    </button>

                                                    <button type="submit" id="createAndContinueCheckBtn" v-if="$route.params.id == undefined" class="btn btn-primary nextBtn btn-lg pull-left save-continue-btn" v-on:click.prevent="CreateCheck(flag='Save and Continue')" >
                                                        <i class="hi-icon icon-flSave-Continue"> </i>  Save and Continue
                                                    </button>

                                                    <button type="submit" id="cancelCheckBtn" class="btn btn-primary nextBtn btn-lg pull-left cancel-btn" v-on:click.prevent="BackChecksList">
                                                        <i class="hi-icon icon-flCancel"> </i>  Cancel
                                                    </button>

                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
export default {
    name: "CheckCreate",

    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        from_number:"",
        from_number_error_msg:"",
        to_number:"",
        to_number_error_msg:"",
        check_status:{
            text: 'Active', value:'active'
        },
        check_status_error_msg:"",
        comment:"",
        check_number:"",
        common_error_msg:"",
        isUpdate:false
    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_check') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {
            self.isUpdate = true;
        }else{
            self.isUpdate = false;
        }

        setTimeout(function () {

            if (segments[3]) {
                self.loadCheckData();
            }
        }, 100);
  },
  methods: {
      BackChecksList() {
        var self = this;
        self.$router.push("/check/list");
      },
      CreateCheck(flag) {
        var self = this;
        var error = false;
        self.from_number_error_msg = "";
        self.to_number_error_msg = "";
        self.check_status_error_msg = "";
        self.common_error_msg = "";

        if (!self.isUpdate) {

            if (!self.from_number || self.from_number == null || self.from_number.trim() == "") {
                self.from_number_error_msg = "From Number Required.";
                error = true;
            }else{
                if ( parseInt(self.from_number.trim(),10) == 0 ) {
                    self.from_number_error_msg = "From Number cannot be zero.";
                    error = true;
                }
            }

            if (!self.to_number || self.to_number == null || self.to_number.trim() == "") {
                self.to_number_error_msg = "To Number Required.";
                error = true;
            }else{
                if ( parseInt(self.to_number.trim(),10) == 0 ) {
                    self.to_number_error_msg = "To Number cannot be zero.";
                    error = true;
                }
            }

            if ( self.from_number.trim() != "" && self.to_number.trim() != "" ) {

                if ( parseInt(self.from_number.trim(),10) == parseInt(self.to_number.trim(),10) ) {
                    self.common_error_msg = "From Number and To Number cannot be same.";
                    error = true;
                }

                if (parseInt(self.to_number.trim(),10) < parseInt(self.from_number.trim(),10)) {
                    self.common_error_msg = "To Number cannot be smaller than From Number.";
                    error = true;
                }

            }
        }

        if (!self.check_status || self.check_status == null || self.check_status == "") {
            self.check_status_error_msg = "Status Required.";
            error = true;
        }

        if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                $("#CreateCheckBtn").val("Updating ...");
                $("#CreateCheckBtn").prop("disabled", true);
                $("#cancelCheckBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueCheckBtn").val("Saving ...");
                    $("#CreateCheckBtn").prop("disabled", true);
                    $("#createAndContinueCheckBtn").prop("disabled", true);
                    $("#cancelCheckBtn").prop("disabled",true);

                } else{

                    $("#CreateCheckBtn").val("Saving ...");
                    $("#CreateCheckBtn").prop("disabled", true);
                    $("#createAndContinueCheckBtn").prop("disabled", true);
                    $("#cancelCheckBtn").prop("disabled",true);
                }
            }

            var fields = $("#checkForm").serializeArray();
            fields.push({name: "status", value: self.check_status.value});
            if ( self.comment != null && self.comment.trim() !="" ) {
                fields.push({name: "comment", value: self.comment});
            }else{
                fields.push({name: "comment", value: ""});
            }
            fields.push({ name: "id", value: segments[3] });
            if (self.isUpdate) {
                fields.push({ name: "flag", value: "update" });
            }else{
                fields.push({ name: "flag", value: "create" });
            }

            $.ajax({
                url: process.env.ROOT_API + "/check/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;

                    if (segments[3]) {
                        $("#CreateCheckBtn").val("Update");
                        $("#CreateCheckBtn").prop("disabled", false);
                        $("#cancelCheckBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueCheckBtn").val("Save and Continue");
                            $("#CreateCheckBtn").prop("disabled", false);
                            $("#createAndContinueCheckBtn").prop("disabled", false);
                            $("#cancelCheckBtn").prop("disabled",false);

                        } else{

                            $("#CreateCheckBtn").val("Save");
                            $("#CreateCheckBtn").prop("disabled", false);
                            $("#createAndContinueCheckBtn").prop("disabled", false);
                            $("#cancelCheckBtn").prop("disabled",false);
                        }
                    }

                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            self.from_number = "";
                            self.to_number = "";
                            self.check_status = {
                                text:"Active",
                                value:"active"
                            };
                            self.comment = "";

                        } else{
                            self.$router.push("/check/list");
                        }

                    } else {

                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3]) {
                        $("#CreateCheckBtn").val("Update");
                        $("#CreateCheckBtn").prop("disabled", false);
                        $("#cancelCheckBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueCheckBtn").val("Save and Continue");
                            $("#CreateCheckBtn").prop("disabled", false);
                            $("#createAndContinueCheckBtn").prop("disabled", false);
                            $("#cancelCheckBtn").prop("disabled",false);

                        } else{

                            $("#CreateCheckBtn").val("Save");
                            $("#CreateCheckBtn").prop("disabled", false);
                            $("#createAndContinueCheckBtn").prop("disabled", false);
                            $("#cancelCheckBtn").prop("disabled",false);
                        }
                    }
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");
                            //EventBus.$emit("logged-in", true, "", "");
                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
        }

      },
      loadCheckData() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/check/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (data.status == "success") {
                    self.check_number = data.content.check_number;
                    self.check_status = {text:
                        self.ucString(data.content.status),
                        value:data.content.status
                    };
                    self.comment = data.content.comment;


                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        //EventBus.$emit("logged-in", true, "", "");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });

      },
      isNumberKey: function(evt) {

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
        } else {
            return true;
        }
      }
  }
}
</script>
<style scoped>
.check-error {
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/check/CheckCreate.vue